import clsx from "clsx";
import { AutocompleteInputRoot } from "./AutocompleteInput.styles";
import { SelectProps } from "../../Select/Select.types";
import { TextFieldProps } from "../../TextField/TextField.types";

/**
 * Props for the `AutocompleteInput` component.
 *
 * Extends `TextFieldProps` (omitting `variant`, which is fixed to `"outlined"`)
 * and adds a `size` prop that maps to the parent `Select`'s sizing scale.
 */
export interface AutocompleteInputProps extends Omit<TextFieldProps, "variant"> {
    /** Additional CSS class names to merge onto the root element. */
    className?: string;
    /** Inline styles applied to the root element. */
    style?: React.CSSProperties;
    /**
     * Controls the visual size of the input, aligned with the parent
     * `Select` component's size scale (`"md"` | `"lg"`).
     */
    size?: SelectProps<string>["size"];
}

/**
 * Internal text input rendered inside the `Autocomplete` dropdown trigger.
 *
 * Renders an `outlined` `TextField` with a size-based CSS modifier class
 * (`"Md"` or `"Lg"`) so that it inherits the correct height from the
 * parent `Select` context.
 *
 * This component is **not intended for direct use** — it is composed
 * internally by `Autocomplete`.
 */
function AutocompleteInput({ className, size, ...rest }: AutocompleteInputProps) {
    return <AutocompleteInputRoot className={clsx("autocomplete-input", size?.capitalize(), className)} variant="outlined" {...rest} />;
}

export default AutocompleteInput;
